<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebページは一つ以上のURLリダイレクトされていません。
        </p>
        <p v-else>
          あなたのWebページは一つ以上のURLリダイレクトされています。
        </p>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          推奨されるリダイレクト回数は1回までです。URLリダイレクトを修正してください。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  }
};
</script>
